import { ContentfulEntryType } from './contentful-entry.type';

export class ResultsType extends ContentfulEntryType {
  public get title(): string {
    return this.fields['title'];
  }

  public get headline(): string {
    return this.fields['headline'];
  }

  public get copy(): string {
    return this.fields['copy'];
  }

  public get smartsaversHeadline(): string {
    return this.fields['smartsaversHeadline'];
  }

  public get dashboardButtonText(): string {
    return this.fields['dashboardButtonText'];
  }

}


